<template>
    <div class="card config-section">
        <CardHeader
            title="Cancelamento Automático de Reservas"
            icon="fas fa-times-circle"
        />
        <div class="card-body">
            <div class="section-form">
                <div
                    class="alert alert-danger"
                    role="alert"
                >
                    <div class="alert-content d-flex gap-2">
                        <i class="fas fa-exclamation-triangle my-auto mr-2"></i>
                        <div>
                            <strong>Atenção:</strong> Reservas não retiradas serão canceladas
                                                      automaticamente após o tempo especificado.
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                for="maximal_hours_cancel"
                                class="form-label"
                            >
                                <span class="required">*</span>
                                Cancelar reservas não retiradas após (horas)
                            </label>
                            <input
                                id="maximal_hours_cancel"
                                type="number"
                                class="form-control"
                                :value="value.maximal_hours_cancel"
                                @input="updateField('maximal_hours_cancel', $event.target.value)"
                                placeholder="Ex: 24"
                                min="1"
                            />
                            <small class="form-text text-muted">
                                Tempo limite para retirada antes do cancelamento automático
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardHeader from "../../Base/CardHeader.vue";

export default {
    name: 'CancellationConfig',
    components: {CardHeader},
    props: {
        value: {type: Object, required: true},
    },
    methods: {
        updateField(field, newValue) {
            this.$emit('update', field, newValue);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Parameters/components/CancellationConfig.vue